export const removeWhitespaces = (str: string) => {
  return str.replace(/\s/g, '')
}

export const stringsEqualWithoutWhitespaces = (str1: string, str2: string) => {
  return removeWhitespaces(str1) === removeWhitespaces(str2)
}
